import HueRed from '@assets/hue_red.svg';
import HueYellow from '@assets/hue_yellow.svg';
import Image from '@atoms/Image/Image';
import { IImage } from '@models/IImage';
import GlowColourEnum from '@models/enums/GlowColourEnum';
import useMediaQuery from '@utils/hooks/useMediaQuery';
import classNames from 'classnames';

interface Props {
  readonly featureText: string;
  readonly subText: string;
  readonly desktopImage?: IImage;
  readonly mobileImage?: IImage;
  readonly backgroundGlow?: GlowColourEnum;
  readonly leftAlignment?: boolean;
}

const SectionHeader = ({
  featureText,
  subText,
  desktopImage,
  mobileImage,
  backgroundGlow,
  leftAlignment,
}: Props) => {
  const isMobile = useMediaQuery(1024);
  const imageToDisplay = isMobile ? mobileImage || desktopImage : desktopImage;

  return (
    <section
      className="bg-white pb-13 lg:pb-[150px] dark:bg-black-100"
      data-testid="CT-156-Section-Header"
    >
      <div className="container flex flex-col items-center justify-center gap-10 overflow-hidden">
        <div className="z-10 flex flex-col gap-7.5 xl:grid xl:grid-cols-12">
          <p
            className={classNames(
              'h2 text-black-100 xl:col-span-6 xl:col-start-4 dark:text-white',
              leftAlignment ? 'text-left' : 'text-center'
            )}
            data-testid="CT-156-Section-Header-Feature-Text"
          >
            {featureText}
          </p>
          <p
            className={classNames(
              'body-two text-grey-500 xl:col-span-6 xl:col-start-4',
              leftAlignment ? 'text-left' : 'text-center'
            )}
            data-testid="CT-156-Section-Header-Subtext"
          >
            {subText}
          </p>
        </div>
        <div className="relative flex h-full w-full flex-col items-center justify-center">
          {backgroundGlow !== GlowColourEnum.None && imageToDisplay && (
            <img
              src={`${backgroundGlow === GlowColourEnum.Yellow ? HueYellow : HueRed}`}
              alt="hue"
              className={classNames(
                'lg:-top-[25rem] md:-top-72 -top-[9.5rem] absolute scale-y-[0.3] opacity-40 lg:scale-x-[1.5]'
              )}
            />
          )}
          {imageToDisplay && (
            <Image
              image={imageToDisplay}
              imageClasses="w-full h-auto"
              classes="z-10 w-full"
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default SectionHeader;
